import { AxiosInstance } from 'axios';
import { ExclusiveAccessService } from '../../../services/Shared/ ExclusiveAccessService';

export interface ExclusiveAccessServiceModel {
  check: ReturnType<typeof ExclusiveAccessService.check>;
}

export const initExclusiveAccessService = (axios: AxiosInstance): ExclusiveAccessServiceModel => ({
  check: ExclusiveAccessService.check(axios),
});
